<template>
  <g>
    <path :d="'M' + B.x + ' ' + B.y + ' L' + C.x + ' ' + C.y + ' L' + D.x + ' ' + D.y + ' L' + E.x + ' ' + E.y + ' L' + A.x + ' ' + A.y + 'Z'" stroke="#b1b1b1" stroke-width="1" :fill="material.color.hex"/>
    <g v-for="side in sides" :key="'side-' + side.id">
      <g v-if="side.rand === saum">
        <path :d="side.saum" stroke-width="1" stroke="#b1b1b1" stroke-dasharray="3,3"/>
        <g v-if="side.rand.oesenArt != inactiveOesen">
          <circle v-for="(item, index) in side.oesenAnzahl" :key="index" :cx="side.oesenAbstand.x(index, side.oesenAnzahl)" :cy="side.oesenAbstand.y(index, side.oesenAnzahl)" r="3" stroke="#b1b1b1" stroke-width="2" fill="#fff" />
        </g>
      </g>
      <path v-if="side.rand === hohlsaum" :d="side.hohlsaum" stroke-width="1" stroke="#b1b1b1"/>
    </g>
    <g v-for="(side, index) in sides" :key="index">
      <line :x1="side.border.line.xStart" :y1="side.border.line.yStart" :x2="side.border.line.xEnd" :y2="side.border.line.yEnd" stroke="#353535" stroke-width="1"/>
      <polygon :points="side.border.corner.start" :transform="side.border.corner.rotateStart" stroke="#353535" stroke-width="1" fill="#353535"/>
      <polygon :points="side.border.corner.end" :transform="side.border.corner.rotateEnd" stroke="#353535" stroke-width="1" fill="#353535"/>
    </g>
    <text v-for="side in sides" :key="'label-' + side.id" :x="side.labelSpace.x" :y="side.labelSpace.y" font-weight="bold" font-family="sans-serif" font-size="2.5em" fill="#232323">{{side.name}}</text>
  </g>
</template>

<script>
import DataRand from './../../../../../data/main/config/setup/rand/randArt'

export default {
  props: ['material', 'rand'],
  data () {
    return {
      A: {
        x: (425 - this.cosCalc(72) * 175 / this.cosCalc(36)) - 175 / this.cosCalc(36),
        y: 200 + this.sinCalc(72) * 175 / this.cosCalc(36)
      },
      B: {
        x: 75,
        y: 200
      },
      C: {
        x: 350 / 2 + 75,
        y: 200 - (this.sinCalc(36) * 175 / this.cosCalc(36))
      },
      D: {
        x: 425,
        y: 200
      },
      E: {
        x: 425 - this.cosCalc(72) * 175 / this.cosCalc(36),
        y: 200 + this.sinCalc(72) * 175 / this.cosCalc(36)
      },
      saum: DataRand.randArt.saum.titleSaum.name,
      hohlsaum: DataRand.randArt.hohlsaum.title.name,
      inactiveOesen: DataRand.randArt.saum.optionsOesenart[0].value.oesenArt
    }
  },
  methods: {
    sinCalc (alpha) {
      return Math.sin(alpha * Math.PI / 180)
    },
    cosCalc (alpha) {
      return Math.cos(alpha * Math.PI / 180)
    }
  },
  computed: {
    sides () {
      return {
        a: {
          name: 'a',
          rand: this.rand.a.type,
          oesenAnzahl: this.rand.a.type === this.saum ? this.rand.a.oesenAnzahl : 0,
          oesenAbstand: {
            xStart: this.A.x + this.sinCalc(36) / this.sinCalc(54) * 15,
            xEnd: this.E.x - this.sinCalc(36) / this.sinCalc(54) * 15,
            yConst: this.A.y - 15,
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              return this.yConst
            }
          },
          saum: 'M' + (this.A.x - 30 / this.sinCalc(72) * this.sinCalc(18)) + ' ' + (this.A.y - 30) + ' L' + (this.E.x + 30 / this.sinCalc(72) * this.sinCalc(18)) + ' ' + (this.E.y - 30),
          hohlsaum: 'M' + (this.A.x - 9 / this.sinCalc(72) * this.sinCalc(18)) + ' ' + (this.A.y - 9) + ' L' + (this.E.x + 9 / this.sinCalc(72) * this.sinCalc(18)) + ' ' + (this.E.y - 9),
          labelSpace: {
            x: 245,
            y: 460
          },
          border: {
            line: {
              xStart: this.A.x,
              yStart: this.A.y + 20,
              xEnd: this.E.x,
              yEnd: this.E.y + 20
            },
            corner: {
              start: this.A.x + ',' + (this.A.y + 20) + ' ' + (this.A.x + 10) + ',' + (this.A.y + 15) + ' ' + (this.A.x + 10) + ',' + (this.A.y + 25),
              rotateStart: 'rotate(0, ' + this.A.x + ', ' + (this.A.y + 20) + ')',
              end: this.E.x + ',' + (this.E.y + 20) + ' ' + (this.E.x - 10) + ',' + (this.E.y + 15) + ' ' + (this.E.x - 10) + ',' + (this.E.y + 25),
              rotateEnd: 'rotate(0, ' + this.E.x + ', ' + (this.E.y + 20) + ')'
            }
          },
          id: 1
        },
        b: {
          name: 'b',
          rand: this.rand.b.type,
          oesenAnzahl: this.rand.b.type === this.saum ? this.rand.b.oesenAnzahl : 0,
          oesenAbstand: {
            xStart: this.B.x + this.sinCalc(72) * 15 / this.sinCalc(54),
            xEnd: this.A.x + this.sinCalc(36) / this.sinCalc(54) * 15,
            yStart: this.B.y + this.sinCalc(18) * 15 / this.sinCalc(54),
            yEnd: this.A.y - 15,
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              if (item === 1) {
                return (this.yStart + this.yEnd) / 2
              } if (item === 2) {
                return this.yStart + i * (this.yEnd - this.yStart)
              } else {
                return this.yStart + (i / (item - 1)) * (this.yEnd - this.yStart)
              }
            }
          },
          saum: 'M' + (this.A.x + 30 / this.sinCalc(72)) + ' ' + this.A.y + ' L' + (this.B.x + this.sinCalc(54) * (30 / this.sinCalc(72))) + ' ' + (this.B.y - this.sinCalc(36) * (30 / this.sinCalc(72))),
          hohlsaum: 'M' + (this.A.x + 9 / this.sinCalc(72)) + ' ' + this.A.y + ' L' + (this.B.x + this.sinCalc(54) * (9 / this.sinCalc(72))) + ' ' + (this.B.y - this.sinCalc(36) * (9 / this.sinCalc(72))),
          labelSpace: {
            x: 55,
            y: 330
          },
          border: {
            line: {
              xStart: this.A.x - this.sinCalc(72) * 20,
              yStart: this.A.y + this.sinCalc(18) * 20,
              xEnd: this.B.x - this.sinCalc(72) * 20,
              yEnd: this.B.y + this.sinCalc(18) * 20
            },
            corner: {
              start: (this.A.x - this.sinCalc(72) * 20) + ',' + (this.A.y + this.sinCalc(18) * 20) + ' ' + (this.A.x - this.sinCalc(72) * 20 - 5) + ',' + (this.A.y + this.sinCalc(18) * 20 - 10) + ' ' + (this.A.x - this.sinCalc(72) * 20 + 5) + ',' + (this.A.y + this.sinCalc(18) * 20 - 10),
              rotateStart: 'rotate(-18, ' + (this.A.x - this.sinCalc(72) * 20) + ', ' + (this.A.y + this.sinCalc(18) * 20) + ')',
              end: (this.B.x - this.sinCalc(72) * 20) + ',' + (this.B.y + this.sinCalc(18) * 20) + ' ' + (this.B.x - this.sinCalc(72) * 20 - 5) + ',' + (this.B.y + this.sinCalc(18) * 20 + 10) + ' ' + (this.B.x - this.sinCalc(72) * 20 + 5) + ',' + (this.B.y + this.sinCalc(18) * 20 + 10),
              rotateEnd: 'rotate(-18, ' + (this.B.x - this.sinCalc(72) * 20) + ', ' + (this.B.y + this.sinCalc(18) * 20) + ')'
            }
          },
          id: 2
        },
        c: {
          name: 'c',
          rand: this.rand.c.type,
          oesenAnzahl: this.rand.c.type === this.saum ? this.rand.c.oesenAnzahl : 0,
          oesenAbstand: {
            xStart: this.B.x + this.sinCalc(72) * 15 / this.sinCalc(54),
            xEnd: this.C.x,
            yStart: this.B.y + this.sinCalc(18) * 15 / this.sinCalc(54),
            yEnd: this.C.y + 15 / this.sinCalc(54),
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              if (item === 1) {
                return (this.yStart + this.yEnd) / 2
              } if (item === 2) {
                return this.yStart + i * (this.yEnd - this.yStart)
              } else {
                return this.yStart + (i / (item - 1)) * (this.yEnd - this.yStart)
              }
            }
          },
          saum: 'M' + (this.B.x + 30 / this.sinCalc(72) * this.sinCalc(18)) + ' ' + (this.B.y + 30) + ' L' + (this.C.x + this.sinCalc(54) * (30 / this.sinCalc(72))) + ' ' + (this.C.y + this.sinCalc(36) * (30 / this.sinCalc(72))),
          hohlsaum: 'M' + (this.B.x + 9 / this.sinCalc(72) * this.sinCalc(18)) + ' ' + (this.B.y + 9) + ' L' + (this.C.x + this.sinCalc(54) * (9 / this.sinCalc(72))) + ' ' + (this.C.y + this.sinCalc(36) * (9 / this.sinCalc(72))),
          labelSpace: {
            x: 130,
            y: 105
          },
          border: {
            line: {
              xStart: this.B.x - this.sinCalc(36) * 20,
              yStart: this.B.y - this.sinCalc(54) * 20,
              xEnd: this.C.x - this.sinCalc(36) * 20,
              yEnd: this.C.y - this.sinCalc(54) * 20
            },
            corner: {
              start: (this.B.x - this.sinCalc(36) * 20) + ',' + (this.B.y - this.sinCalc(54) * 20) + ' ' + (this.B.x - this.sinCalc(36) * 20 - 5) + ',' + (this.B.y - this.sinCalc(54) * 20 - 10) + ' ' + (this.B.x - this.sinCalc(36) * 20 + 5) + ',' + (this.B.y - this.sinCalc(54) * 20 - 10),
              rotateStart: 'rotate(54, ' + (this.B.x - this.sinCalc(36) * 20) + ', ' + (this.B.y - this.sinCalc(54) * 20) + ')',
              end: (this.C.x - this.sinCalc(36) * 20) + ',' + (this.C.y - this.sinCalc(54) * 20) + ' ' + (this.C.x - this.sinCalc(36) * 20 - 5) + ',' + (this.C.y - this.sinCalc(54) * 20 + 10) + ' ' + (this.C.x - this.sinCalc(36) * 20 + 5) + ',' + (this.C.y - this.sinCalc(54) * 20 + 10),
              rotateEnd: 'rotate(54, ' + (this.C.x - this.sinCalc(36) * 20) + ', ' + (this.C.y - this.sinCalc(54) * 20) + ')'
            }
          },
          id: 3
        },
        d: {
          name: 'd',
          rand: this.rand.d.type,
          oesenAnzahl: this.rand.d.type === this.saum ? this.rand.d.oesenAnzahl : 0,
          oesenAbstand: {
            xStart: this.C.x,
            xEnd: this.D.x - this.sinCalc(72) * 15 / this.sinCalc(54),
            yStart: this.C.y + 15 / this.sinCalc(54),
            yEnd: this.D.y + this.sinCalc(18) * 15 / this.sinCalc(54),
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              if (item === 1) {
                return (this.yStart + this.yEnd) / 2
              } if (item === 2) {
                return this.yStart + i * (this.yEnd - this.yStart)
              } else {
                return this.yStart + (i / (item - 1)) * (this.yEnd - this.yStart)
              }
            }
          },
          saum: 'M' + (this.D.x - 30 / this.sinCalc(72) * this.sinCalc(18)) + ' ' + (this.D.y + 30) + ' L' + (this.C.x - this.sinCalc(54) * (30 / this.sinCalc(72))) + ' ' + (this.C.y + this.sinCalc(36) * (30 / this.sinCalc(72))),
          hohlsaum: 'M' + (this.D.x - 9 / this.sinCalc(72) * this.sinCalc(18)) + ' ' + (this.D.y + 9) + ' L' + (this.C.x - this.sinCalc(54) * (9 / this.sinCalc(72))) + ' ' + (this.C.y + this.sinCalc(36) * (9 / this.sinCalc(72))),
          labelSpace: {
            x: 350,
            y: 105
          },
          border: {
            line: {
              xStart: this.C.x + this.sinCalc(36) * 20,
              yStart: this.C.y - this.sinCalc(54) * 20,
              xEnd: this.D.x + this.sinCalc(36) * 20,
              yEnd: this.D.y - this.sinCalc(54) * 20
            },
            corner: {
              start: (this.C.x + this.sinCalc(36) * 20) + ',' + (this.C.y - this.sinCalc(54) * 20) + ' ' + (this.C.x + this.sinCalc(36) * 20 - 5) + ',' + (this.C.y - this.sinCalc(54) * 20 - 10) + ' ' + (this.C.x + this.sinCalc(36) * 20 + 5) + ',' + (this.C.y - this.sinCalc(54) * 20 - 10),
              rotateStart: 'rotate(126, ' + (this.C.x + this.sinCalc(36) * 20) + ', ' + (this.C.y - this.sinCalc(54) * 20) + ')',
              end: (this.D.x + this.sinCalc(36) * 20) + ',' + (this.D.y - this.sinCalc(54) * 20) + ' ' + (this.D.x + this.sinCalc(36) * 20 - 5) + ',' + (this.D.y - this.sinCalc(54) * 20 + 10) + ' ' + (this.D.x + this.sinCalc(36) * 20 + 5) + ',' + (this.D.y - this.sinCalc(54) * 20 + 10),
              rotateEnd: 'rotate(126, ' + (this.D.x + this.sinCalc(36) * 20) + ', ' + (this.D.y - this.sinCalc(54) * 20) + ')'
            }
          },
          id: 4
        },
        e: {
          name: 'e',
          rand: this.rand.e.type,
          oesenAnzahl: this.rand.e.type === this.saum ? this.rand.e.oesenAnzahl : 0,
          oesenAbstand: {
            xStart: this.D.x - this.sinCalc(72) * 15 / this.sinCalc(54),
            xEnd: this.E.x - this.sinCalc(36) / this.sinCalc(54) * 15,
            yStart: this.D.y + this.sinCalc(18) * 15 / this.sinCalc(54),
            yEnd: this.E.y - 15,
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              if (item === 1) {
                return (this.yStart + this.yEnd) / 2
              } if (item === 2) {
                return this.yStart + i * (this.yEnd - this.yStart)
              } else {
                return this.yStart + (i / (item - 1)) * (this.yEnd - this.yStart)
              }
            }
          },
          saum: 'M' + (this.E.x - 30 / this.sinCalc(72)) + ' ' + this.E.y + ' L' + (this.D.x - this.sinCalc(54) * (30 / this.sinCalc(72))) + ' ' + (this.D.y - this.sinCalc(36) * (30 / this.sinCalc(72))),
          hohlsaum: 'M' + (this.E.x - 9 / this.sinCalc(72)) + ' ' + this.E.y + ' L' + (this.D.x - this.sinCalc(54) * (9 / this.sinCalc(72))) + ' ' + (this.D.y - this.sinCalc(36) * (9 / this.sinCalc(72))),
          labelSpace: {
            x: 425,
            y: 330
          },
          border: {
            line: {
              xStart: this.D.x + this.sinCalc(72) * 20,
              yStart: this.D.y + this.sinCalc(18) * 20,
              xEnd: this.E.x + this.sinCalc(72) * 20,
              yEnd: this.E.y + this.sinCalc(18) * 20
            },
            corner: {
              start: (this.D.x + this.sinCalc(72) * 20) + ',' + (this.D.y + this.sinCalc(18) * 20) + ' ' + (this.D.x + this.sinCalc(72) * 20 - 5) + ',' + (this.D.y + this.sinCalc(18) * 20 + 10) + ' ' + (this.D.x + this.sinCalc(72) * 20 + 5) + ',' + (this.D.y + this.sinCalc(18) * 20 + 10),
              rotateStart: 'rotate(18, ' + (this.D.x + this.sinCalc(72) * 20) + ', ' + (this.D.y + this.sinCalc(18) * 20) + ')',
              end: (this.E.x + this.sinCalc(72) * 20) + ',' + (this.E.y + this.sinCalc(18) * 20) + ' ' + (this.E.x + this.sinCalc(72) * 20 - 5) + ',' + (this.E.y + this.sinCalc(18) * 20 - 10) + ' ' + (this.E.x + this.sinCalc(72) * 20 + 5) + ',' + (this.E.y + this.sinCalc(18) * 20 - 10),
              rotateEnd: 'rotate(18, ' + (this.E.x + this.sinCalc(72) * 20) + ', ' + (this.E.y + this.sinCalc(18) * 20) + ')'
            }
          },
          id: 5
        }
      }
    }
  }
}
</script>

<style>
</style>
